import "css/tailwind.css";
import "styles/admin/admin.less";
// Roboto fonts are used in MUI components
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import * as Sentry from "@sentry/browser";
import { render } from "react-dom";
import { AppContainer } from "react-hot-loader";
import configureStore from "util/configure-store";
import { copyLoader } from "util/copy-loader";
import versionJson from "../../version.json";
import initDataDog from "./datadog";
import Root from "./v2-root";
import routes from "./v2-routes";

const store = configureStore();
window.store = store;

const { version } = versionJson;

const domElement = document.getElementById("content-holder");
const basename = "/app";

// Top-level function that renders App
function renderApp() {
  copyLoader(() =>
    render(
      <AppContainer>
        <Root store={store} routes={routes} basename={basename} />
      </AppContainer>,
      domElement,
    ),
  );
}

// Configure Sentry in staging and prod only
if (!!process.env.SENTRY_ENV) {
  const sentryOptions = {
    dsn: "https://b87bd6d0c16e4be3a82529b6760981df@sentry.io/79582",
    environment: process.env.SENTRY_ENV,
  };
  // Only attach release in production
  if (process.env.SENTRY_ENV === "production") {
    sentryOptions.release = version;
  }

  Sentry.init(sentryOptions);

  // Datadog
  initDataDog();
}

let impersonating = getParameterByName("impersonating");

try {
  // if impersonation token specified in URL, save it
  if (impersonating) {
    sessionStorage.setItem("impersonating", impersonating);
  } else {
    // otherwise check if it was already saved
    impersonating = sessionStorage.getItem("impersonating");
  }
} catch (er) {
  // stub storage methods
  window.sessionStorage = {
    getItem: () => {},
    setItem: () => {},
  };
}

// Initial render
renderApp();

// Hot Module Replacement in dev only
if (process.env.NODE_ENV !== "production") {
  if (module.hot) {
    module.hot.accept("./v2-routes", () => {
      renderApp();
    });
  }
}
